export default "__VITE_ASSET__C0S5jHxr__"